var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "md-layout",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.changePassword.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "md-field",
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("message.password")))]),
            _vm._v(" "),
            _c("md-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|min:6",
                  expression: "'required|min:6'",
                },
              ],
              ref: "password",
              attrs: { type: "password", name: _vm.$t("message.newPassword") },
              model: {
                value: _vm.resetPasswordFields.newPassword,
                callback: function ($$v) {
                  _vm.$set(_vm.resetPasswordFields, "newPassword", $$v)
                },
                expression: "resetPasswordFields.newPassword",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "md-field",
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("message.passwordRepeat")))]),
            _vm._v(" "),
            _c("md-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|confirmed:password",
                  expression: "'required|confirmed:password'",
                },
              ],
              attrs: {
                name: _vm.$t("message.passwordRepeat"),
                type: "password",
              },
              model: {
                value: _vm.resetPasswordFields.newPasswordRepeat,
                callback: function ($$v) {
                  _vm.$set(_vm.resetPasswordFields, "newPasswordRepeat", $$v)
                },
                expression: "resetPasswordFields.newPasswordRepeat",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "md-button",
          {
            staticClass: "md-primary",
            attrs: { type: "submit", disabled: _vm.loading },
          },
          [
            _vm.loading
              ? _c("md-progress-spinner", {
                  staticClass: "md-accent",
                  attrs: { "md-diameter": 20, "md-mode": "indeterminate" },
                })
              : _c("span", [_vm._v(_vm._s(_vm.$t("message.changePassword")))]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }